import { useQuery, useQueryClient } from "@tanstack/react-query"
import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"

type Props = {
  campId: string
  isStore?: boolean
  page?: number
  perPage?: number
}

export const useOrders = (props: Props) => {
  const fetchOrders = useQuery({
    queryKey: [queryKeys.ORDERS, props.campId, props.isStore, props.page, props.perPage],
    queryFn: () => apiFetchOrders(props.campId, { isStore: props.isStore, page: props.page, perPage: props.perPage }),
    gcTime: 0,
    enabled: !!props.campId,
  })

  const indexData = fetchOrders.data?.orders || []
  const indexPagination = fetchOrders.data?.meta

  return {
    index: {
      ...{ ...fetchOrders, data: indexData },
      totalPages: indexPagination?.total_pages,
      totalCount: indexPagination?.total_count
    },
    isLoading: fetchOrders.isLoading,
  }
}

const apiFetchOrders = async (
  campId: string,
  options: {
    isStore?: boolean
    page?: number
    perPage?: number
  } = {}
) => {
  if (!campId) return

  const filteredOptions = Object.fromEntries(Object.entries(options).filter(([_, value]) => value !== undefined))

  try {
    const resp = await api2.Orders.all(campId, filteredOptions)
    return resp
  } catch (error) {
    console.error("Error fetching order:", error)
    throw error
  }
}
